import { SET_AUTH_USER } from '../reduxType';

const initialState = {
  access_token: null,
  defpassword: null,
  expired_at: null,
  refresh_token: null,
  user_id: null,
  isLoading: false,
};

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case SET_AUTH_USER:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
